import {EntityType, PropertyDefinition, PropertyDefinitionConfig} from '../types';

export const TEMPLATE_PROPERTY_NUMBER_REPOSITORY: PropertyDefinitionConfig = {
	id: 'idPropertyDefinitionNumberRepository',
	singular: 'Number Field',
};

export const TEMPLATE_PROPERTY_NUMBER_TEMPLATE_PROPERTIES: PropertyDefinition[] = [{
	id: 'idPropertyDefinitionNumberTemplateTitleProperty',
	parentId: TEMPLATE_PROPERTY_NUMBER_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'label',
	label: 'Label',
	required: true,
	autoFocus: true,
}, {
	id: 'idPropertyDefinitionNumberTemplateSlugProperty',
	parentId: TEMPLATE_PROPERTY_NUMBER_REPOSITORY.id,
	type: EntityType.PropertyDefinitionString,
	slug: 'slug',
	label: 'Key',
	required: true,
	disabled: true,
}, {
	id: 'idPropertyDefinitionNumberTemplateRequiredProperty',
	parentId: TEMPLATE_PROPERTY_NUMBER_REPOSITORY.id,
	type: EntityType.PropertyDefinitionBoolean,
	slug: 'required',
	label: 'Required',
	required: true,
	defaultChecked: true,
}];
